/**
 * Menu Repository Implementation
 * Implements IMenuRepository interface
 */

import { inject, injectable } from "inversify";
import type { MenuItem } from "../../domain/model/MenuModel";
import type { IMenuRepository } from "../../domain/repository/IMenuRepository";
import { MenuApiService } from "../remote/service/MenuApiService";
import type { MenuItemDto } from "../remote/response/MenuResponse";

@injectable()
export class MenuRepositoryImpl implements IMenuRepository {
  @inject(MenuApiService)
  private readonly apiService!: MenuApiService;

  async fetchMenus(): Promise<readonly MenuItem[]> {
    const dtos = await this.apiService.fetchMenus();
    return dtos.map((dto) => this.mapDtoToModel(dto));
  }

  private mapDtoToModel(dto: MenuItemDto): MenuItem {
    return {
      menuId: dto.menuId,
      title: dto.title,
      icon: dto.icon,
      routePath: dto.routePath,
      sortOrder: dto.sortOrder,
      badge: dto.badge
        ? {
            value: dto.badge.value,
            variant: dto.badge.variant,
          }
        : undefined,
      subMenus: dto.subMenus?.map((sub) => this.mapDtoToModel(sub)),
    };
  }
}

